var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"error","disabled":"","icon":""}},[_c('v-icon',[_vm._v("mdi-bug")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }